<template>
  <section>
    <v-container fluid>
      <v-row class="justify-end align-center">
        <v-col cols="auto" class="ml-auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1">
      <v-data-table
        :headers="headers"
        :items="breaks"
        :search="search"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100]
        }"
        show-expand
        single-expand
        item-key="id"
        :expanded.sync="expanded"
      >
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-container>
              <p class="grey--text text--darken-2 mb-0">
                <v-icon small left color="info">mdi-information</v-icon>
                <span class="font-weight-bold pr-1">Comentario: </span>
                {{ item.comment }}
              </p>
            </v-container>
          </td>
        </template>

        <template v-slot:item.user.name="{ item }">
          <v-list two-line max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="d-block d-md-none mr-2">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.user.name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.user.email"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar size="40" tile>
                <v-avatar
                  size="40"
                  :color="
                    $vuetify.theme.dark
                      ? 'blue-grey darken-4'
                      : 'blue-grey lighten-5'
                  "
                >
                  <v-img
                    v-if="item.url_image"
                    :src="item.url_image"
                    alt="Avatar del usuario"
                  ></v-img>
                  <v-icon color="blue-grey" v-else>mdi-account</v-icon>
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content class="d-none d-md-block ml-3">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.user.name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.user.email"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>

        <template v-slot:item.comment="{ item }">
          <v-chip
            outlined
            :color="item.comment == null ? 'error' : 'success'"
            dark
            >{{
              item.comment === null ? "Sin Comentario" : item.comment
            }}</v-chip
          >
        </template>

        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                small
                class="mr-2"
                @click.stop="UnlockAgent(item)"
                >mdi-account-check-outline</v-icon
              >
            </template>
            <span>Desbloquear Agente</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <!-- <v-row justify="end">
            <v-col cols="auto">
                <v-pagination
                    circle
                    color="primary"
                    v-model="page"
                    :length="pageCount"
                ></v-pagination>
            </v-col>
        </v-row> -->

    <v-dialog v-model="showComment" max-width="300">
      <v-card>
        <v-card-title class="headline">Agregar Comentario</v-card-title>

        <v-card-text>
          <v-textarea
            name="comment"
            label="Comentario"
            v-model="comment"
          ></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="showComment = false"
            >Canelar</v-btn
          >

          <v-btn color="green darken-1" text @click="unlockConfirm"
            >Continuar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
export default {
  data() {
    return {
      expanded: [],
      singleExpand: false,
      search: "",
      headers: [
        {
          text: "Agente",
          value: "user.name",
          class: "primary--text",
          width: "30%"
        },
        {
          text: "Fecha de bloqueo",
          value: "updated_at",
          class: "primary--text",
          width: "15%"
        },
        {
          text: "Nombre de la pausa",
          align: "left",
          sortable: false,
          value: "pause.name",
          class: "primary--text",
          width: "20%"
        },
        {
          text: "Duración",
          value: "pause.time",
          class: "primary--text",
          width: "15%"
        },
        {
          text: "Tiempo transcurrido",
          value: "timeOut",
          class: "primary--text",
          width: "15%"
        },
        {
          text: "Desbloqueado por:",
          value: "administrator.name",
          class: "primary--text",
          width: "20%"
        }
        // { text: "Comentario", value: "comment" }
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      Agent: {},
      comment: "",
      showComment: false
    };
  },
  async created() {
    await this.getBreaks();
  },
  computed: {
    breaks() {
      return this.$store.getters["breaks/GET_BREAK_UNLOCK"];
    }
  },
  methods: {
    async getBreaks() {
      try {
        const response = await this.$store.dispatch(
          "breaks/SHOW_AGENTS_BREAKS_UNLOCK"
        );
        // console.log(response);
      } catch (error) {
        console.log(error);
      }
    },
    UnlockAgent(item) {
      this.showComment = true;
      this.Agent = item;
    },
    async unlockConfirm() {
      const enviar = {
        comment: this.comment,
        id: this.Agent.id
      };
      const response = await this.$store.dispatch(
        "breaks/UNLOCK_AGENTS",
        enviar
      );
      alert(response.data.message);
    }
  }
};
</script>

<style></style>
